import React from 'react'
import Player from '../Player'

export type DemoMediaItemProps = {
    id: string;
    autoPlay: boolean
    source: string;
}

const DemoMediaItem = (props: DemoMediaItemProps) => {
    const { id, source } = props
    let extension = get_url_extension(source)
    if (!extension) { return <div></div> }
    const videoExtensions = ['mp4', 'webm']
    const isVideo = videoExtensions.find(x => x == extension) !== undefined
    if (!extension || extension == '' || extension === source) {
        return <div></div>
    }

    const renderPlayer = () => {
        return (
            <Player id={id} autoplay={props.autoPlay} source={source} />
        )
    }
    const renderImage = () => {
        return (
            <img id={id} src={source} className='demo-img' />
        )
    }

    return isVideo ? renderPlayer() : renderImage()
}

export default DemoMediaItem

function get_url_extension(url: string) {
    if (url) {
        let extension = url.split(/[#?]/)[0].split('.')?.pop()
        if (extension === url) { return } // Ignore. Not a file
        return extension?.trim()?.toLowerCase()
    }
}